import {ChangeDetectionStrategy, Component, Input, OnDestroy} from '@angular/core'
import {faTimes} from '@fortawesome/pro-regular-svg-icons/faTimes'
import {LinkService} from '../../../../core/i18n/link.service'
import {DocumentService} from '../../../../craft/utils/document.service'
import {faUser} from '@fortawesome/pro-solid-svg-icons/faUser'
import {TranslocoService} from '@ngneat/transloco'
import {CalculatorsService} from '../calculators.service'

@Component({
  selector: 'bgo-calculator-navbar',
  templateUrl: './calculator-navbar.component.html',
  styles: [':host { display: block }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalculatorNavbarComponent implements OnDestroy {
  @Input() exitButtonText?: string
  readonly closeIcon = faTimes
  readonly contactIcon = faUser

  constructor(
    private readonly documentService: DocumentService,
    private readonly calculatorsService: CalculatorsService,
    private readonly translocoService: TranslocoService,
    readonly linkService: LinkService,
  ) {}

  ngOnDestroy(): void {
    this.documentService.enablePageScroll()
  }

  close(): void {
    this.calculatorsService.close(this.exitButtonText || this.translocoService.translate('calculators.close.exit'))
  }
}
